import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const VykupTisk = lazy(() =>
  import('@/modules/ojeta-vozidla/VykupTisk').then((m) => ({ default: m.VykupTisk })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/vykup/$id/tisk',
  component: () => (
    <Suspense fallback={null}>
      <VykupTisk />
    </Suspense>
  ),
});
